export default "__VITE_PUBLIC_ASSET__ce0cc9da__"